"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Contexts_1 = require("../Contexts");
class ObjectComponent extends react_1.default.Component {
    getChildrenComponents() {
        return this.renderChildrenComponent();
    }
    renderChildrenComponent() {
        return (react_1.default.createElement(Contexts_1.ParentFieldNameContext.Provider, { value: this.props.fieldName }, this.props.children));
    }
    renderErrorMessage() {
        if (!this.props.errorMessage)
            return;
        return (react_1.default.createElement("div", { style: { color: 'red' }, className: "srf_errorMessage" }, this.props.errorMessage));
    }
    render() {
        return (react_1.default.createElement("div", { style: { marginTop: 20, marginBottom: 20, padding: 20 } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("b", null, this.props.label)),
            this.renderErrorMessage(),
            this.getChildrenComponents()));
    }
}
exports.default = ObjectComponent;
//# sourceMappingURL=index.js.map